import { useEffect } from 'preact/hooks';
import { createPortal } from 'preact/compat';
import css from './Lightbox.module.css';

/**
 * Полноэкранный просмотр картинки. Закрывается кликом по фону или Esc.
 *
 * Рендерится порталом в document.body: иначе `position: fixed` считается не от
 * вьюпорта, а от ближайшего родителя с transform/will-change (у модалок и
 * контейнеров такие есть) — и на телефоне окно «прилипало» к верху прокрутки,
 * а не появлялось в текущей позиции экрана.
 */
export function Lightbox({ src, alt = '', onClose }) {
  useEffect(() => {
    function onKey(e) {
      if (e.key === 'Escape') onClose?.();
    }
    document.addEventListener('keydown', onKey);
    // Пока открыт просмотр — блокируем прокрутку фона.
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = prevOverflow;
    };
  }, [onClose]);

  if (!src) return null;

  return createPortal(
    <div
      class={css.overlay}
      role="dialog"
      aria-modal="true"
      aria-label="Фото товара"
      onClick={(e) => {
        // Закрываем по клику по фону — но не по самому фото/кнопке
        if (e.target.classList.contains(css.overlay)) onClose?.();
      }}
    >
      {/* Обёртка ужимается под размер фото, поэтому кнопка садится точно на угол снимка */}
      <div class={css.figure}>
        <img class={css.img} src={src} alt={alt} />
        <button type="button" class={css.close} onClick={onClose} aria-label="Закрыть">
          <svg
            viewBox="0 0 24 24"
            width="20"
            height="20"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            fill="none"
            aria-hidden="true"
          >
            <path d="M6 6 L18 18 M18 6 L6 18" />
          </svg>
        </button>
      </div>
    </div>,
    document.body,
  );
}
